<div class="main-content">
  <!-- Ordine di vendita - codice identificativo -->
  <app-header
    [title]="'HEADER.TITLE_SALES_ORDER_DETAIL' | translate"
    [subtitle]="'HEADER.SUBTITLE_SALES_ORDER_DETAIL' | translate"
  />

  <div class="row mt-5">
    <div class="col-12 d-flex justify-content-end gap-3">
      <button
        class="create-doc-button"
        [routerLink]="['/repository', 'sales-order', salesOrderId]"
        *appHasRole="['ADMIN', 'CUSTOMER', 'CUSTOMER_PARTNER', 'PARTNER']"
      >
        {{ 'SALES_ORDER_DOCUMENTS.SALES_ORDER_DETAIL_BUTTON' | translate }}
      </button>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <app-icam-container [iconName]="'repository'" [iconColor]="'white'">
        <app-icam-tabs
          [tabs]="tabs"
          [selectedTabId]="selectedTabId"
          (tabChange)="onTabChange($event)"
          [showArrow]="true"
        ></app-icam-tabs>

        <app-table
          [allValues$]="allSalesOrderDocuments$"
          [type]="'sales_order_documents'"
          (selectedFilter)="onFilterSelected($event)"
          [hasChart]="false"
          (selectedPage)="onPageSelected($event)"
          [prevPage]="salesOrderDocPrevPage"
          [currentPage]="salesOrderDocCurrentPage"
          [nextPage]="salesOrderDocNextPage"
          [totalPages]="salesOrderDocTotalPages"
          [hasKeywordFilter]="false"
          [showTitle]="false"
          [useInlineKeywordFilter]="true"
          (deleteRow)="onDeleteDocument($event)"
        />
      </app-icam-container>
    </div>
  </div>
  @if (!showSuccess && !showError) {
    <div class="mt-4 mb-4">
      @if (!showSuccess && !showError) {
        <app-back-button [linkText]="'REQUEST.BACK_TO_REQUEST'" (click)="goBack()" />
      }
    </div>
  }
</div>
<app-footer-copyright />
